/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import cx from 'classnames';

import { Icon } from 'sarsaparilla';

import type { SearchResultItem } from '../../api/search/search.types';
import { getCardRating } from '../utils/rating';

import styles from './CardStarRating.module.scss';

interface CardStarRatingProps {
    item: SearchResultItem;
    className?: string;
}

export function CardStarRating({ item, className }: CardStarRatingProps) {
    if (!item.average_rating || !item.number_of_ratings) return null;

    const { averageRating, reviewCount, ratingAriaLabel } = getCardRating(item);

    return (
        <div className={cx(styles.rating, className)}>
            <Icon
                iconName="star"
                size="sm"
                className={styles.starIcon}
                aria-hidden="true"
            />

            <span className={styles.ratingValue} aria-hidden="true">
                {averageRating}
            </span>

            <span className={styles.reviewCount} aria-hidden="true">
                {`(${reviewCount} reviews)`}
            </span>

            <div className="rec-sr-only">{ratingAriaLabel}</div>
        </div>
    );
}
